export default __webpack_public_path__ + "78750ed166f50743136bf4e563e5b35a.png";